import React from 'react';
import styles from './Divider.module.css';

export const Divider = () => {
  return <div className={styles.divider} />;
};
